import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TaskRefContext } from "../../types/apiTypes";
import { AuxiliaryTask, Employee, HoverTaskType, TransportationTask, WorkTask } from "../../types/ganttChart";

export type TaskHoverBoxAction = {
  payload: {
    type: HoverTaskType;
    task: WorkTask | TransportationTask | AuxiliaryTask;
    employee?: Employee;
  };
};

type NexusErrorModal = {
  failedTasks?: TaskRefContext[];
  message?: string;
};

type OverlaySlice = {
  taskIsHovered?: {
    type: HoverTaskType;
    task: WorkTask | TransportationTask | AuxiliaryTask;
    employee?: Employee;
  };
  nexusErrorModal?: NexusErrorModal;
}

const initialState: OverlaySlice = {}

const overlaySlice = createSlice({
  name: "overlay",
  initialState,
  reducers: {
    showTaskHoverBox(state, action: TaskHoverBoxAction) {
      state.taskIsHovered = action.payload;
    },
    hideTaskHoverBox(state) {
      delete state.taskIsHovered;
    },
    openNexusErrorModal(state, action: PayloadAction<NexusErrorModal>) {
      state.nexusErrorModal = action.payload;
    },
    closeNexusErrorModal(state) {
      if (state.nexusErrorModal) {
        delete state.nexusErrorModal;
      }
    },
  }
})

export const {
  showTaskHoverBox,
  hideTaskHoverBox,
  openNexusErrorModal,
  closeNexusErrorModal,
} = overlaySlice.actions;

export default overlaySlice.reducer